import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: {
      title: 'Your ride information link — Checktak',
    },
  },
  {
    path: '/order',
    name: 'order',
    component: () => import(/* webpackChunkName: "OrderView" */ '../views/OrderView.vue'),
    meta: {
      title: 'Your ride information link — Checktak',
    },
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

// Глобальный навигационный хук для установки title
router.beforeEach((to, from, next) => {
  // Установка title из meta
  if (to.meta.title) {
    document.title = to.meta.title
  } else {
    document.title = 'Checktak' // title по умолчанию
  }
  
  // Проверка авторизации (если нужно)
  if (to.meta.requiresAuth) {
    const store = require('../store').default
    if (!store.getters.isAuthenticated) {
      next('/')
      return
    }
  }
  
  next()
})

export default router
